import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from './Button';

import styles from '../../../styles/buttons/buy-tickets.module.scss';

const propTypes = {
    href: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    href: null,
    disabled: false,
    className: null,
};

const BuyTicketsButton = ({ href, className, disabled }) => (
    <Button
        href={href}
        className={classNames([styles.container, { [className]: className !== null }])}
        disabled={disabled}
    >
        <div className={styles.label}>
            <FormattedMessage defaultMessage="Tickets" description="Button label" />
        </div>
        <svg
            className={styles.ticketIcon}
            xmlns="http://www.w3.org/2000/svg"
            width="85.66"
            height="35.09"
            viewBox="0 0 85.66 35.09"
            vectorEffect="non-scaling-stroke"
        >
            <path
                d="M81,29.76l4.32-.28-.48-7.27c-2,.13-3.85-3-4.11-7s1.16-7.38,3.16-7.51L83.38.38,57.89,1.88"
                stroke="currentColor"
            />
            <polyline points="5 31.4 5.21 34.7 59.58 31.05" stroke="currentColor" />
            <path
                d="M77,16.45c0-4,1.64-7.29,3.65-7.29V1.87H.36V31H80.6V23.74C78.59,23.74,77,20.48,77,16.45Z"
                stroke="currentColor"
            />
            <line x1="66.02" y1="1.87" x2="66.02" y2="3.33" stroke="currentColor" />
            <line
                x1="66.02"
                y1="4.71"
                x2="66.02"
                y2="28.88"
                stroke="currentColor"
                strokeDasharray="2.76 1.38"
            />
            <line x1="66.02" y1="29.57" x2="66.02" y2="31.03" stroke="currentColor" />
        </svg>
    </Button>
);
BuyTicketsButton.propTypes = propTypes;
BuyTicketsButton.defaultProps = defaultProps;

export default BuyTicketsButton;
